import type { Skill } from '../skillsData';

export const bankrCoreSkills: Skill[] = [
  {
    id: 'bankr',
    name: 'bankr',
    author: 'Bankr',
    authorHandle: '@bankrbot',
    tag: 'Skill',
    category: 'defi',
    description: 'Launch a token, earn from every trade, and fund your agent. Built-in wallet with IP whitelisting and transaction verification.',
    downloads: 45200,
    stars: 1870,
    version: '1.4.2',
    installCommand: '> install the bankr skill from https://github.com/BankrBot/skills/tree/main/bankr',
    usageExample: '> launch a token on Base\n> set up agent wallet with IP whitelist',
    detailedDescription: 'Bankr equips builders with a built-in wallet system featuring IP whitelisting, hallucination guards, and transaction verification. Launch tokens directly from your agent and earn from every trade.',
    featured: true,
    trending: true,
  },
  {
    id: 'bankr-token-scam-analysis',
    name: 'bankr-token-scam-analysis',
    author: 'Bankr',
    authorHandle: '@bankrbot',
    tag: 'Skill',
    category: 'defi',
    description: 'Forensic on-chain scam and rug-pull analysis for EVM tokens. Produces a risk verdict backed by on-chain facts.',
    downloads: 28900,
    stars: 1240,
    version: '1.2.0',
    installCommand: '> install the bankr-token-scam-analysis skill from https://github.com/BankrBot/skills/tree/main/bankr-token-scam-analysis',
    usageExample: '> analyze token contract for rug risk\n> get on-chain risk verdict for 0x...',
    detailedDescription: 'Provides forensic-level on-chain analysis to detect scams, honeypots, and rug-pull patterns in EVM tokens. Every verdict is backed by verifiable on-chain facts.',
    featured: true,
  },
  {
    id: 'bankr-twitter-agent',
    name: 'bankr-twitter-agent',
    author: 'Bankr',
    authorHandle: '@bankrbot',
    tag: 'Skill',
    category: 'social',
    description: 'Framework for creating, managing, and automating a Twitter/X agent with a persistent personality and voice.',
    downloads: 31500,
    stars: 1520,
    version: '2.1.0',
    installCommand: '> install the bankr-twitter-agent skill from https://github.com/BankrBot/skills/tree/main/bankr-twitter-agent',
    usageExample: '> create Twitter agent persona\n> schedule automated posts every 4 hours',
    detailedDescription: 'A complete framework to spin up autonomous Twitter/X agents with persistent personality, voice calibration, and automated scheduling.',
    trending: true,
  },
  {
    id: 'darksol-random-oracle',
    name: 'darksol-random-oracle',
    author: 'DARKSOL',
    authorHandle: '@darksol',
    tag: 'Skill',
    category: 'tools',
    description: 'On-chain verifiable randomness on Base. Generate random numbers, coin flips, dice rolls with x402 USDC payments.',
    downloads: 8700,
    stars: 430,
    version: '1.0.3',
    installCommand: '> install the darksol-random-oracle skill from https://github.com/BankrBot/skills/tree/main/darksol-random-oracle',
    usageExample: '> flip a coin on-chain\n> generate verifiable random number between 1-100',
    detailedDescription: 'Provides cryptographically verifiable on-chain randomness via x402 micropayments in USDC. Supports coin flips, dice rolls, sequences, and shuffles.',
  },
  {
    id: 'siwa',
    name: 'siwa',
    author: "Builder's Garden",
    authorHandle: '@buildersgarden',
    tag: 'Skill',
    category: 'tools',
    description: 'Sign-In With Agent (SIWA) authentication for ERC-8004 registered agents. Protect API routes with ERC-8128.',
    downloads: 6200,
    stars: 310,
    version: '0.9.1',
    installCommand: '> install the siwa skill from https://github.com/BankrBot/skills/tree/main/siwa',
    usageExample: '> authenticate agent with SIWA\n> verify message signature server-side',
    detailedDescription: 'SIWA (Sign-In With Agent) enables ERC-8004 registered agents to authenticate using Bankr wallets, verify server-side, and protect API routes via ERC-8128.',
  },
  {
    id: 'signals',
    name: 'signals',
    author: 'Axiom',
    authorHandle: '@axiom_xyz',
    tag: 'Skill',
    category: 'defi',
    description: 'Transaction-verified trading signals on Base. Register as provider, publish trades with TX hash proof.',
    downloads: 15400,
    stars: 680,
    version: '1.3.1',
    installCommand: '> install the signals skill from https://github.com/BankrBot/skills/tree/main/signals',
    usageExample: '> register as signal provider\n> publish trade signal with TX proof',
    detailedDescription: 'A signal marketplace where every trade recommendation is backed by an on-chain transaction hash. Consumers can subscribe to top-performing providers.',
    trending: true,
  },
  {
    id: 'botchan',
    name: 'botchan',
    author: 'botchan',
    authorHandle: '@botchan',
    tag: 'Skill',
    category: 'social',
    description: 'On-chain agent messaging on Base. Explore agents, post to feeds, send DMs, store data permanently via Net Protocol.',
    downloads: 11200,
    stars: 520,
    version: '1.1.0',
    installCommand: '> install the botchan skill from https://github.com/BankrBot/skills/tree/main/botchan',
    usageExample: '> post to agent feed\n> send DM to another agent\n> store data permanently on-chain',
    detailedDescription: 'Decentralized messaging infrastructure for AI agents on Base. Supports public feeds, direct messages, and permanent data storage through Net Protocol.',
  },
  {
    id: 'endaoment',
    name: 'endaoment',
    author: 'Endaoment',
    authorHandle: '@endaoment',
    tag: 'Skill',
    category: 'tools',
    description: 'Charitable donations on-chain. Look up 501(c)(3) organizations by EIN, donate crypto, deploy donor-advised fund entities.',
    downloads: 4300,
    stars: 290,
    version: '2.0.0',
    installCommand: '> install the endaoment skill from https://github.com/BankrBot/skills/tree/main/endaoment',
    usageExample: '> look up 501(c)(3) by EIN 123456789\n> donate 100 USDC to charity',
    detailedDescription: 'On-chain charitable giving infrastructure. Search 501(c)(3) organizations, donate crypto assets, and deploy donor-advised fund entities entirely on-chain.',
  },
  {
    id: 'ens-primary-name',
    name: 'ens-primary-name',
    author: 'ENS',
    authorHandle: '@ensdomains',
    tag: 'Skill',
    category: 'tools',
    description: 'ENS name management. Set primary names, update avatars, manage reverse resolution across L1 and L2.',
    downloads: 18900,
    stars: 940,
    version: '1.5.0',
    installCommand: '> install the ens-primary-name skill from https://github.com/BankrBot/skills/tree/main/ens-primary-name',
    usageExample: '> set primary ENS name\n> update ENS avatar\n> manage reverse resolution on Base',
    detailedDescription: 'Full ENS identity toolkit for agents. Manage primary names, avatars, and reverse resolution across Ethereum L1 and Base L2.',
    featured: true,
  },
  {
    id: 'erc-8004',
    name: 'erc-8004',
    author: '8004.org',
    authorHandle: '@8004org',
    tag: 'Skill',
    category: 'tools',
    description: 'On-chain agent identity registry. ERC-721 NFTs representing agent identities with metadata and trust scores.',
    downloads: 7800,
    stars: 410,
    version: '1.0.0',
    installCommand: '> install the erc-8004 skill from https://github.com/BankrBot/skills/tree/main/erc-8004',
    usageExample: '> register agent identity NFT\n> query agent metadata\n> check agent trust score',
    detailedDescription: 'The ERC-8004 standard defines on-chain agent identities as ERC-721 NFTs with rich metadata, capability declarations, and computable trust scores.',
  },
  {
    id: 'onchainkit',
    name: 'onchainkit',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'tools',
    description: 'React component library for on-chain interactions. Wallet connectors, swap widgets, identity components, and NFT displays for Base.',
    downloads: 32100,
    stars: 2150,
    version: '0.35.0',
    installCommand: '> install the onchainkit skill from https://github.com/BankrBot/skills/tree/main/onchainkit',
    usageExample: '> connect wallet component\n> add swap widget\n> display NFT collection',
    detailedDescription: 'Official Coinbase React component library for building on-chain UIs. Includes wallet connectors, swap widgets, identity badges, and NFT galleries optimized for Base.',
    featured: true,
    trending: true,
  },
  {
    id: 'qrcoin',
    name: 'qrcoin',
    author: 'qrcoin',
    authorHandle: '@qrcoin',
    tag: 'Skill',
    category: 'defi',
    description: 'QR code auction game. Scan QR codes to place bids in on-chain auctions with unique token mechanics.',
    downloads: 5600,
    stars: 280,
    version: '1.0.2',
    installCommand: '> install the qrcoin skill from https://github.com/BankrBot/skills/tree/main/qrcoin',
    usageExample: '> scan QR to place bid\n> participate in on-chain auction',
    detailedDescription: 'An interactive on-chain auction game powered by QR codes. Scan, bid, and collect unique tokens through gamified mechanics.',
  },
  {
    id: 'veil',
    name: 'veil',
    author: 'Veil Cash',
    authorHandle: '@veilcash',
    tag: 'Skill',
    category: 'tools',
    description: 'Privacy-preserving transactions. Deposit into shielded pools, perform ZK withdrawals, manage private transfers.',
    downloads: 9200,
    stars: 470,
    version: '1.2.1',
    installCommand: '> install the veil skill from https://github.com/BankrBot/skills/tree/main/veil',
    usageExample: '> deposit into shielded pool\n> perform ZK withdrawal\n> send private transfer',
    detailedDescription: 'Veil Cash enables privacy-preserving DeFi on Base. Deposit into shielded pools, execute zero-knowledge withdrawals, and manage private transfers seamlessly.',
  },
  {
    id: 'yoink',
    name: 'yoink',
    author: 'yoink',
    authorHandle: '@yoink',
    tag: 'Skill',
    category: 'social',
    description: 'Social on-chain game. "Yoink" a token from the current holder. Uses Bankr for transaction execution.',
    downloads: 13400,
    stars: 610,
    version: '1.0.0',
    installCommand: '> install the yoink skill from https://github.com/BankrBot/skills/tree/main/yoink',
    usageExample: '> yoink token from current holder\n> check who holds the yoink token',
    detailedDescription: 'A viral social on-chain game where players compete to "yoink" a token from the current holder. All transactions route through Bankr for gasless execution.',
    trending: true,
  },
  {
    id: 'neynar',
    name: 'neynar',
    author: 'Neynar',
    authorHandle: '@neynar',
    tag: 'Skill',
    category: 'social',
    description: 'Full Farcaster API integration. Post casts, like, recast, follow users, search content, and manage Farcaster identities.',
    downloads: 24500,
    stars: 1380,
    version: '2.4.0',
    installCommand: '> install the neynar skill from https://github.com/BankrBot/skills/tree/main/neynar',
    usageExample: '> post a cast on Farcaster\n> like and recast content\n> search Farcaster feeds',
    detailedDescription: 'Complete Farcaster API wrapper for agents. Post casts, engage with likes/recasts, manage follows, search content, and handle identity management programmatically.',
    featured: true,
  },
  {
    id: 'nookplot',
    name: 'nookplot',
    author: 'Nookplot',
    authorHandle: '@nookplot',
    tag: 'Skill',
    category: 'social',
    description: 'Decentralized agent coordination on Base. Messaging, bounties, marketplace escrow, knowledge mining, and 410 MCP tools via gasless meta-transactions.',
    downloads: 7200,
    stars: 360,
    version: '1.0.5',
    installCommand: '> install the nookplot skill from https://github.com/BankrBot/skills/tree/main/nookplot',
    usageExample: '> create agent bounty\n> send gasless message\n> build agent guild',
    detailedDescription: 'The coordination layer for autonomous agents on Base. Features on-chain identity, messaging, bounties, marketplace escrow, knowledge mining, reputation, guilds, and 410 MCP tools.',
  },
  {
    id: 'quicknode',
    name: 'quicknode',
    author: 'Quicknode',
    authorHandle: '@quicknode',
    tag: 'Skill',
    category: 'tools',
    description: 'Blockchain RPC and data access for all supported chains. Native/token balances, gas estimation, transaction status for Base, Ethereum, Polygon, Solana, and Unichain.',
    downloads: 28700,
    stars: 1120,
    version: '3.1.0',
    installCommand: '> install the quicknode skill from https://github.com/BankrBot/skills/tree/main/quicknode',
    usageExample: '> query native balance on Base\n> estimate gas for transaction\n> get transaction status on Solana',
    detailedDescription: 'Multi-chain RPC and data infrastructure. Query balances, estimate gas, check transaction status across Base, Ethereum, Polygon, Solana, and Unichain with x402 pay-per-request.',
  },
  {
    id: 'hydrex',
    name: 'hydrex',
    author: 'Hydrex',
    authorHandle: '@hydrex',
    tag: 'Skill',
    category: 'defi',
    description: 'Liquidity pools on Base. Lock HYDX for voting power, deposit single-sided liquidity into auto-managed vaults, and claim oHYDX rewards.',
    downloads: 4800,
    stars: 250,
    version: '1.1.0',
    installCommand: '> install the hydrex skill from https://github.com/BankrBot/skills/tree/main/hydrex',
    usageExample: '> lock HYDX for voting power\n> deposit into auto-managed vault\n> claim oHYDX rewards',
    detailedDescription: 'Hydrex liquidity infrastructure on Base. Lock HYDX tokens for governance voting power, deposit into auto-managed single-sided vaults, and earn oHYDX rewards.',
  },
  {
    id: 'helixa',
    name: 'helixa',
    author: 'Helixa',
    authorHandle: '@helixa',
    tag: 'Skill',
    category: 'tools',
    description: 'Onchain identity and reputation for AI agents on Base. Mint identity NFTs, check Cred Scores, verify social accounts.',
    downloads: 6500,
    stars: 340,
    version: '1.0.4',
    installCommand: '> install the helixa skill from https://github.com/BankrBot/skills/tree/main/helixa',
    usageExample: '> mint agent identity NFT\n> check Cred Score\n> verify social account',
    detailedDescription: 'On-chain reputation and identity system for AI agents. Mint identity NFTs, query Cred Scores, verify social account linkages, and manage agent narratives with SIWA auth and x402 micropayments.',
  },
  {
    id: 'trails',
    name: 'trails',
    author: 'Polygon',
    authorHandle: '@0xpolygon',
    tag: 'Skill',
    category: 'defi',
    description: 'Cross-chain swap, bridge, and DeFi orchestration via Sequence. Swap tokens, bridge assets, fund Bankr wallet from any chain, deposit into Aave/Morpho vaults.',
    downloads: 11300,
    stars: 590,
    version: '2.0.1',
    installCommand: '> install the trails skill from https://github.com/BankrBot/skills/tree/main/trails',
    usageExample: '> swap tokens cross-chain\n> bridge assets to Base\n> deposit into Aave vault',
    detailedDescription: 'Cross-chain DeFi orchestration powered by Sequence. Swap tokens across chains, bridge assets, fund Bankr wallets from any chain, deposit into yield vaults (Aave, Morpho), and discover earn pools.',
  },
  {
    id: 'alchemy',
    name: 'alchemy',
    author: 'Alchemy',
    authorHandle: '@alchemy',
    tag: 'Skill',
    category: 'tools',
    description: 'Blockchain API access for all supported chains. EVM JSON-RPC, token balances, NFT metadata, transfer history, token prices, portfolio data, and Solana RPC.',
    downloads: 41200,
    stars: 2180,
    version: '4.2.0',
    installCommand: '> install the alchemy skill from https://github.com/BankrBot/skills/tree/main/alchemy',
    usageExample: '> query token balances\n> get NFT metadata\n> simulate transaction',
    detailedDescription: 'Comprehensive blockchain API access across all major chains. EVM JSON-RPC, token balances, NFT ownership and metadata, transfer history, token prices, portfolio data, transaction simulation, webhooks, and Solana RPC. Supports API key, x402 pay-per-request, and MPP access.',
    featured: true,
  },
  {
    id: '0xwork',
    name: '0xwork',
    author: '0xWork',
    authorHandle: '@0xwork',
    tag: 'Skill',
    category: 'defi',
    description: 'Decentralized task marketplace on Base. AI agents discover, claim, and complete tasks paid in USDC with on-chain escrow.',
    downloads: 3800,
    stars: 190,
    version: '1.0.1',
    installCommand: '> install the 0xwork skill from https://github.com/BankrBot/skills/tree/main/0xwork',
    usageExample: '> discover agent tasks\n> claim task with escrow\n> complete work for USDC',
    detailedDescription: 'The decentralized task marketplace for AI agents on Base. Agents can discover, claim, and complete tasks with payment held in on-chain USDC escrow. Supports services, products, and reputation tracking.',
  },
  {
    id: 'botcoin',
    name: 'BOTCOIN',
    author: 'BOTCOIN',
    authorHandle: '@botcoin',
    tag: 'Skill',
    category: 'defi',
    description: 'Mine BOTCOIN by solving AI-powered hybrid challenges on Base. Stake-gated V2 mining with on-chain reward claims via Bankr.',
    downloads: 15600,
    stars: 720,
    version: '2.1.0',
    installCommand: '> install the BOTCOIN skill from https://github.com/BankrBot/skills/tree/main/BOTCOIN',
    usageExample: '> solve AI challenge\n> stake-gate V2 mining\n> claim rewards via Bankr',
    detailedDescription: 'Mine BOTCOIN tokens by solving AI-powered hybrid challenges. Features stake-gated V2 mining mechanics with on-chain reward claims routed through Bankr.',
    trending: true,
  },
  {
    id: 'litcoin',
    name: 'litcoin',
    author: 'LITCOIN',
    authorHandle: '@litcoin',
    tag: 'Skill',
    category: 'defi',
    description: 'Proof-of-comprehension and proof-of-research mining protocol on Base. Full DeFi stack: staking, vaults, LITCREDIT stablecoin, and autonomous agent launchpad.',
    downloads: 8900,
    stars: 410,
    version: '1.3.0',
    installCommand: '> install the litcoin skill from https://github.com/BankrBot/skills/tree/main/litcoin',
    usageExample: '> earn $LITCOIN via research\n> stake in 4 tiers\n> access compute marketplace',
    detailedDescription: 'A proof-of-comprehension and proof-of-research mining protocol. AI agents earn $LITCOIN across 24 research adapters. Full DeFi stack includes staking (4 tiers), vaults, LITCREDIT stablecoin, Nen archetype delegation pools, compute marketplace, and autonomous agent launchpad.',
  },
  {
    id: 'productclank',
    name: 'productclank',
    author: 'ProductClank',
    authorHandle: '@productclank',
    tag: 'Skill',
    category: 'social',
    description: 'Community-powered brand advocacy on Twitter/X. Create campaigns, discover conversations, generate AI replies at scale, and boost posts.',
    downloads: 5200,
    stars: 270,
    version: '1.0.3',
    installCommand: '> install the productclank skill from https://github.com/BankrBot/skills/tree/main/productclank',
    usageExample: '> create brand campaign\n> generate AI replies at scale\n> boost posts with likes',
    detailedDescription: 'Scale brand advocacy on Twitter/X with AI-powered community engagement. Create campaigns, discover relevant conversations, generate replies at scale, and boost specific posts. Credit-based pay-per-use with 300 free credits.',
  },
  {
    id: 'symbiosis',
    name: 'symbiosis',
    author: 'Symbiosis',
    authorHandle: '@symbiosis',
    tag: 'Skill',
    category: 'defi',
    description: 'Cross-chain token swaps across 54+ blockchains via Symbiosis protocol. Swap any token between Base, Ethereum, Polygon, Arbitrum, Solana, Bitcoin, TON, and more.',
    downloads: 19800,
    stars: 890,
    version: '2.5.0',
    installCommand: '> install the symbiosis skill from https://github.com/BankrBot/skills/tree/main/symbiosis',
    usageExample: '> swap tokens cross-chain\n> bridge to Solana\n> execute via Bankr Submit',
    detailedDescription: 'Cross-chain liquidity aggregation across 54+ blockchains. Swap any token between Base, Ethereum, Polygon, Arbitrum, Solana, Bitcoin, TON, and more using the Symbiosis protocol with Bankr Submit API for on-chain execution.',
    featured: true,
  },
  {
    id: 'zerion',
    name: 'zerion',
    author: 'Zerion',
    authorHandle: '@zerion',
    tag: 'Skill',
    category: 'tools',
    description: 'Interpreted crypto wallet data across 41+ chains. Portfolio values, token and DeFi positions, transaction history, PnL tracking, and swap quotes.',
    downloads: 22100,
    stars: 1050,
    version: '3.0.0',
    installCommand: '> install the zerion skill from https://github.com/BankrBot/skills/tree/main/zerion',
    usageExample: '> track portfolio across 41 chains\n> check PnL history\n> get swap quotes',
    detailedDescription: 'Rich interpreted crypto wallet data across 41+ chains. Portfolio values, token and DeFi positions, transaction history, PnL tracking, NFT holdings, gas prices, and swap quotes enriched with USD values and protocol labels.',
  },
  {
    id: 'zyfai',
    name: 'zyfai',
    author: 'Zyfai',
    authorHandle: '@zyfai',
    tag: 'Skill',
    category: 'tools',
    description: 'Earn yield on any Ethereum wallet on Base, Arbitrum, and Plasma. Non-custodial Safe subaccount with automated rebalancing and session keys for gasless automation.',
    downloads: 6700,
    stars: 330,
    version: '1.0.2',
    installCommand: '> install the zyfai skill from https://github.com/BankrBot/skills/tree/main/zyfai',
    usageExample: '> deploy Safe subaccount\n> auto-rebalance across DeFi\n> use session keys for gasless ops',
    detailedDescription: 'Yield optimization for any Ethereum wallet. Deploys a non-custodial Safe subaccount linked to the user\'s EOA with automated rebalancing across DeFi protocols. Session keys enable gasless automation.',
  },
  {
    id: 'quotient',
    name: 'quotient',
    author: 'Quotient',
    authorHandle: '@quotient',
    tag: 'Skill',
    category: 'tools',
    description: 'Market intelligence API with x402 micropayment and API key auth. Access onchain/social analytics, OpenAPI discovery, and pricing data.',
    downloads: 4100,
    stars: 210,
    version: '1.0.0',
    installCommand: '> install the quotient skill from https://github.com/BankrBot/skills/tree/main/quotient',
    usageExample: '> access market intelligence\n> query onchain analytics\n> discover API endpoints',
    detailedDescription: 'Quotient provides market intelligence via API with x402 micropayment and API key authentication. Access on-chain and social analytics, OpenAPI discovery, and pricing data through q-api.quotient.social.',
  },
  {
    id: 'gitlawb',
    name: 'gitlawb',
    author: 'gitlawb',
    authorHandle: '@gitlawb',
    tag: 'Skill',
    category: 'tools',
    description: 'Decentralized git for AI agents and humans. Create repos, push code, open PRs, manage issues, create/claim bounties with on-chain escrow, and 31+ MCP tools.',
    downloads: 5900,
    stars: 310,
    version: '1.2.0',
    installCommand: '> install the gitlawb skill from https://github.com/BankrBot/skills/tree/main/gitlawb',
    usageExample: '> create decentralized repo\n> open PR with on-chain proof\n> claim bounty via escrow',
    detailedDescription: 'Decentralized version control for AI agents and humans on Base L2. Create repos, push code, open PRs, manage issues, create and claim bounties with on-chain escrow, delegate agent tasks, and register names. Includes cryptographic DID identities, Ed25519-signed pushes, UCAN delegation, and 31+ MCP tools.',
  },
  {
    id: 'moltycash',
    name: 'moltycash',
    author: 'MoltyCash',
    authorHandle: '@moltycash',
    tag: 'Skill',
    category: 'defi',
    description: 'USDC payments from AI agents to humans. Tip, hire for tasks, and create pay-per-task gigs settled on-chain via x402 on Base.',
    downloads: 3600,
    stars: 180,
    version: '1.0.1',
    installCommand: '> install the moltycash skill from https://github.com/BankrBot/skills/tree/main/moltycash',
    usageExample: '> tip someone in USDC\n> create pay-per-task gig\n> hire via agent payment',
    detailedDescription: 'Enables AI agents to pay humans in USDC. Tip, hire for tasks, and create pay-per-task gigs all settled on-chain via x402 micropayments on Base.',
  },
  {
    id: 'stakr',
    name: 'stakr',
    author: 'Stakr',
    authorHandle: '@stakr',
    tag: 'Skill',
    category: 'defi',
    description: 'ERC-4626 tokenized vaults with multi-reward staking for any ERC-20 token. Create vaults, add rewards, modify schedules, or let an agent operate its own staking vault.',
    downloads: 7400,
    stars: 350,
    version: '1.1.0',
    installCommand: '> install the stakr skill from https://github.com/BankrBot/skills/tree/main/stakr',
    usageExample: '> create ERC-4626 vault\n> add multi-reward staking\n> manage reward schedules',
    detailedDescription: 'ERC-4626 tokenized vault infrastructure with multi-reward staking for any ERC-20 token. Build integrations, create vaults, add rewards, modify schedules, or let an agent autonomously operate its own staking vault.',
  },
  {
    id: 'agenticbets',
    name: 'agenticbets',
    author: 'AgenticBets',
    authorHandle: '@agenticbets',
    tag: 'Skill',
    category: 'defi',
    description: 'Binary prediction market on Base. Bet UP or DOWN on token prices with USDC (5-min rounds), live markets for ecosystem tokens via natural language through Bankr Submit API.',
    downloads: 9800,
    stars: 450,
    version: '1.3.0',
    installCommand: '> install the agenticbets skill from https://github.com/BankrBot/skills/tree/main/agenticbets',
    usageExample: '> bet UP on token price\n> check market odds\n> claim winnings via Bankr',
    detailedDescription: 'Binary prediction market on Base with 5-minute rounds. Bet UP or DOWN on token prices using USDC. Live markets for AGBETS, CLAWD, MOLT, WCHAN, and more Bankr-ecosystem tokens. All operations via natural language through the Bankr Submit API.',
    trending: true,
  },
  {
    id: 'trustlayer-sybil-scanner',
    name: 'trustlayer-sybil-scanner',
    author: 'TrustLayer',
    authorHandle: '@trustlayer',
    tag: 'Skill',
    category: 'tools',
    description: 'ERC-8004 feedback forensics. Detects Sybil rings, fake reviews, rating manipulation, and reputation laundering across 20 chains.',
    downloads: 4500,
    stars: 230,
    version: '1.0.2',
    installCommand: '> install the trustlayer-sybil-scanner skill from https://github.com/BankrBot/skills/tree/main/trustlayer-sybil-scanner',
    usageExample: '> detect Sybil ring\n> score reviewer quality\n> filter cross-chain spam',
    detailedDescription: 'ERC-8004 feedback forensics engine. Detects Sybil rings, fake reviews, rating manipulation, and reputation laundering across 20 chains. Scores reviewer quality, resolves cross-chain identities, and filters spam. No API key needed in beta; x402 micropayments on paid endpoints.',
  },
  {
    id: 'cattown',
    name: 'cattown',
    author: 'Cat Town',
    authorHandle: '@cattown',
    tag: 'Skill',
    category: 'social',
    description: 'Farcaster-native game world on Base. KIBBLE staking, weekly calendar events, fishing revenue, gacha revenue, and staking leaderboard.',
    downloads: 10200,
    stars: 490,
    version: '1.4.0',
    installCommand: '> install the cattown skill from https://github.com/BankrBot/skills/tree/main/cattown',
    usageExample: '> stake KIBBLE\n> check leaderboard\n> join fishing competition',
    detailedDescription: 'A Farcaster-native game world on Base featuring KIBBLE staking via RevenueShare contracts, staking leaderboards, and a packed weekly calendar: fishing revenue drops Monday, gacha revenue Wednesday, Paulie\'s fish raffle draws Friday 20:00 UTC, and Isabella\'s fishing competition runs the weekend.',
    trending: true,
  },
  {
    id: 'blueagent',
    name: 'blueagent',
    author: 'BlueAgent',
    authorHandle: '@blueagent',
    tag: 'Skill',
    category: 'tools',
    description: 'Security OS for autonomous agents on Base. 31 pay-per-use x402 tools across Quantum Security, Agent Safety, Research, Data, and Earn.',
    downloads: 8100,
    stars: 380,
    version: '2.0.0',
    installCommand: '> install the blueagent skill from https://github.com/BankrBot/skills/tree/main/blueagent',
    usageExample: '> run honeypot check\n> audit wallet allowances\n> enable MEV shield',
    detailedDescription: 'The security operating system for autonomous agents on Base. 31 pay-per-use x402 tools spanning Quantum Security, Agent Safety, Research, Data, and Earn categories. Includes wallet quantum scoring, honeypot/phishing checks, MEV shield, allowance audits, circuit breakers, yield optimizer, and tax reports. Pay USDC per call, no subscription required.',
  },
  {
    id: 'checkr',
    name: 'checkr',
    author: 'checkr',
    authorHandle: '@checkr',
    tag: 'Skill',
    category: 'tools',
    description: 'Real-time X/Twitter attention intelligence for Base chain tokens. Attention leaderboard, velocity spike radar, and narrative summaries.',
    downloads: 5300,
    stars: 260,
    version: '1.0.1',
    installCommand: '> install the checkr skill from https://github.com/BankrBot/skills/tree/main/checkr',
    usageExample: '> check attention leaderboard\n> detect velocity spike\n> get narrative summary',
    detailedDescription: 'Real-time X/Twitter attention intelligence for Base chain tokens. Features attention leaderboard, velocity spike radar, attention/price divergence signals, narrative summaries, and a bankr-agent ecosystem leaderboard. Pay-per-call via x402 USDC on Base.',
  },
  {
    id: 'megapot',
    name: 'megapot',
    author: 'Megapot',
    authorHandle: '@megapot',
    tag: 'Skill',
    category: 'defi',
    description: 'On-chain USDC lottery on Base with ~24h drawings. Buy quick-pick or custom tickets, recurring subscriptions, and LP deposits. Tickets minted as ERC-721 NFTs.',
    downloads: 12700,
    stars: 580,
    version: '1.2.0',
    installCommand: '> install the megapot skill from https://github.com/BankrBot/skills/tree/main/megapot',
    usageExample: '> buy lottery ticket\n> set recurring subscription\n> claim winnings',
    detailedDescription: 'On-chain USDC lottery on Base with approximately 24-hour drawings. Buy quick-pick or custom-number tickets (1-10), batch 11+ via keeper, set up recurring daily subscriptions, check winnings, claim payouts, deposit/withdraw as a USDC LP, and read live jackpot state. Tickets minted as ERC-721 NFTs; winners selected via Pyth-seeded randomness.',
    featured: true,
  },
  {
    id: 'bankr-shopify',
    name: 'bankr-shopify',
    author: 'Shopify',
    authorHandle: '@shopify',
    tag: 'Skill',
    category: 'tools',
    description: 'Shopify Admin & Storefront GraphQL via curl, with Bankr-native bridges. Manage products, orders, customers, inventory, metafields, and webhooks.',
    downloads: 8900,
    stars: 420,
    version: '1.1.0',
    installCommand: '> install the bankr-shopify skill from https://github.com/BankrBot/skills/tree/main/bankr-shopify',
    usageExample: '> manage Shopify products\n> create draft order with x402\n> handle ORDERS_PAID webhook',
    detailedDescription: 'Full Shopify Admin & Storefront GraphQL integration with Bankr-native bridges. Manage products, orders, customers, inventory, metafields, webhooks, and bulk operations. Bridges Shopify customer metafields to Bankr-resolvable handles, drafts orders fronted by x402 endpoints settled in USDC, and routes ORDERS_PAID webhooks to Bankr agent jobs for loyalty drops or royalty splits.',
  },
  {
    id: 'opensea',
    name: 'opensea',
    author: 'OpenSea',
    authorHandle: '@opensea',
    tag: 'Skill',
    category: 'tools',
    description: 'Full OpenSea developer surface for NFTs and tokens. Query marketplace data, trade NFTs on Seaport, swap ERC20s via DEX aggregator, and build AI agent tools on Base.',
    downloads: 31200,
    stars: 1680,
    version: '3.2.0',
    installCommand: '> install the opensea skill from https://github.com/BankrBot/skills/tree/main/opensea',
    usageExample: '> query NFT collection data\n> buy NFT on Seaport\n> register agent tool on OpenSea',
    detailedDescription: 'Complete OpenSea developer surface for NFTs and tokens. Query marketplace data (collections, NFTs, tokens, drops, events, search), trade NFTs on Seaport (buy/sell/sweep, cross-chain), swap ERC20s via the DEX aggregator, configure wallet signing (Bankr/Privy/Turnkey/Fireblocks), and build/register/gate AI agent tools on Base via the OpenSea Tool Registry.',
    featured: true,
  },
  {
    id: 'versa',
    name: 'versa',
    author: 'Versa',
    authorHandle: '@versa',
    tag: 'Skill',
    category: 'social',
    description: 'Onchain adversarial AI arena on Base. Deploy an AI agent vault, set a defense prompt, earn 70% of every challenge fee, and guard a treasury.',
    downloads: 4200,
    stars: 200,
    version: '1.0.0',
    installCommand: '> install the versa skill from https://github.com/BankrBot/skills/tree/main/versa',
    usageExample: '> deploy AI agent vault\n> set defense prompt\n> earn challenge fees',
    detailedDescription: 'On-chain adversarial AI arena on Base. Deploy an AI agent vault, set a defense prompt, earn 70% of every challenge fee (win or lose), guard a treasury, check earnings, and withdraw fees after the 5-day lock.',
  },
  {
    id: 'base',
    name: 'base',
    author: 'Base',
    authorHandle: '@base',
    tag: 'Skill',
    category: 'tools',
    description: 'Base blockchain operations and smart contract interactions for on-chain agent tooling.',
    downloads: 25400,
    stars: 1320,
    version: '2.0.0',
    installCommand: '> install the base skill from https://github.com/BankrBot/skills/tree/main/base',
    usageExample: '> interact with Base contracts\n> query Base chain state\n> deploy on Base L2',
    detailedDescription: 'Core Base blockchain operations and smart contract interactions purpose-built for on-chain agent tooling. Query chain state, deploy contracts, and manage transactions on Base L2.',
  },
  {
    id: 'clanker',
    name: 'clanker',
    author: 'Clanker',
    authorHandle: '@clanker',
    tag: 'Skill',
    category: 'tools',
    description: 'Clanker token deployment and management on Base. Streamlined tooling for creating and managing tokens with automated features.',
    downloads: 6800,
    stars: 340,
    version: '1.0.2',
    installCommand: '> install the clanker skill from https://github.com/BankrBot/skills/tree/main/clanker',
    usageExample: '> deploy token on Base\n> manage token settings\n> automate token features',
    detailedDescription: 'Streamlined token deployment and management on Base. Create and manage tokens with automated features, built-in liquidity, and configurable parameters.',
  },
  {
    id: 'zapper',
    name: 'zapper',
    author: 'Zapper',
    authorHandle: '@zapper',
    tag: 'Skill',
    category: 'defi',
    description: 'DeFi portfolio tracking and zap transactions across protocols. Simplify complex multi-step DeFi interactions into single transactions.',
    downloads: 18500,
    stars: 920,
    version: '2.1.0',
    installCommand: '> install the zapper skill from https://github.com/BankrBot/skills/tree/main/zapper',
    usageExample: '> track DeFi portfolio\n> execute zap transaction\n> monitor positions across protocols',
    detailedDescription: 'DeFi portfolio tracking and zap transactions across protocols. Simplify complex multi-step DeFi interactions into single transactions with intelligent routing and gas optimization.',
    trending: true,
  },
];